import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const MonthlyDeaths = () => {
    const { chartData } = useResultsChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução mensal de óbitos'}
            horizontal={true}
            subtitles={chartData?.monthlyDeaths?.map((item) => item.description)}
            values={chartData?.monthlyDeaths?.map((item) => item.total  ||  0)}
            height={450}
        />
    );
};
